<template>
  <div class="animated fadeIn list-of-customer">
    <b-card>
      <div slot="header">Customer  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6" class="pr-5">
          <b-form-group label-cols=3 label="Customer Name">
              <b-form-input v-model="tblData.CustName"></b-form-input>
          </b-form-group>
          <b-form-group label-cols=3 label="Customer Code">
              <b-row>
                <b-col  cols="4">
                  <b-form-input v-model="tblData.CustCode" placeholder="Customer Code"></b-form-input>
                </b-col>
                <b-col  cols="8">
                    <b-form-group label-cols=3 label="Group/Type">
                      <b-form-select v-model="tblData.customer_group" :plain="true" :options="customerGroups" ></b-form-select>
                          <b-form-checkbox v-if="(user.iklan==1)" class="ml-1 mt-2" v-model="tblData.advertiser" value="1" unchecked-value="0">ADVERTISER/BRAND OWNER</b-form-checkbox>
                    </b-form-group>                          
                </b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group label-cols=3 label="Sales(AE) | Collector">
              <b-row>
                <b-col class="pr-1" cols="5"><b-form-input v-model="tblData.SalesCode" placeholder="Sales (AE)"></b-form-input></b-col>
                <b-col class="pl-1" cols="6"><b-form-input v-model="tblData.collector" placeholder="Collector"></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
          <b-form-group label-cols=3 label="Contact Name">
              <b-row>
                <b-col class="pr-1" cols="5"><b-form-input v-model="tblData.contact" placeholder="contact name"></b-form-input></b-col>
                <b-col class="pl-1" cols="7">
                  <b-form-group label-cols=3 label="NPWP">
                      <b-form-input v-model="tblData.npwp" placeholder="NPWP No."></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>   
              <b-row>
                <b-col class="pl-1" offset="6" cols="6">
                  <b-row class="text-right">
                    <b-button class="btn btn-success ml-3 mr-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                  </b-row>
                </b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover 
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;" >Edit</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;" > Delete</b-dropdown-item>
        </b-dropdown>
      </template>        

        <template v-slot:cell(Address)="data">
          {{ data.item.Address1 }}
          {{ data.item.Address2 }}
        </template>
        <template v-slot:cell(PhoneNo)="data">
          <span v-if="(data.item.PhoneNo)">P.{{data.item.PhoneNo}}</span>&nbsp;
          <span v-if="(data.item.FaxNo)">F.{{data.item.FaxNo}}</span>
        </template>
        <template v-slot:cell(CreditLimit)="data">
          {{data.item.CreditLimit | numFormat}}
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
  .list-of-customer {
    table {
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
 }
</style>


<script>
import toastr from "mini-toastr";
import customer from "../../apis/customer";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
toastr.init();

export default {
  components: {Loading},
  data() {
    return {
      namamenu:'',
      showDelConfirm: false,
      horizontal: true,
      showFilter:false,
      isLoading:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      user: this.$store.state.user,
      terpilih:{customer_id:''},
      limit:15,
      pagination: false,      
      tblFields:[
        {
          key: "action",
          label: "",
          thClass: "text-center",
        },
          {
            key: "CustName",
            label: "Customer Name",
            sortable: true
          },
          {
            key: "CustCode",
            thStyle: "width:50px",
            label: "Code",
            sortable: true
          },
          {
            key: "Address",
            label: "Billing Address",
          },
          {
            key: "City",
            label: "City",
            sortable: true
          },
          {
            key: "PhoneNo",
            label: "Phone/Fax",
            thStyle: "width:150px",
          },
          {
            key: "npwp",
            label: "N P W P",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "customer_group",
            label: "Group"
          },
          {
            key: "collector",
            label: "Collector",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "SalesCode",
            label: "Sales (AE)",
            thStyle: "width:150px",
            sortable: true
          },
        ],
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: null,
        sortDesc: false,
        customer_group: ''
      }
    };
  },
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },      
  },  
  created: async function() {
      this.namamenu=this.$route.name;
        if (this.namamenu=='koran.customer'){
            this.tblData.customer_group= "KORANAGEN";
        } else {
          this.tblData.customer_group= "";
        }

      const groups = await customer.group();
      this.customerGroups = groups.reduce((newArr, item) => {
                      newArr.push(item);
                  return newArr;
              }, [{value:'',text:'---ALL---'}]);
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.custlist) {
            this.tblData[key] = filter.custlist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.custlist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.custlist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await customer.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              const list = await customer.list(this.tblData);
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.CustName = '';
        this.tblData.CustCode =  '';
        this.tblData.contact =  '';
        this.tblData.customer_group = '';
        this.tblData.SalesCode =  '';
        this.tblData.collector =  '';
        this.tblData.koran = '';
        this.tblData.iklan =  '';
        this.tblData.npwp =  '';        
        this.tblData.advertiser =  '';
        // this.refresh();
    },
    saveFilter() {
      const keys = ['name', 'code', 'customer_group', 'contact', 'SalesCode', 'collector','koran','iklan','npwp', 'advertiser'];
      let filtered = false;
      const custlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              custlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          custlist.page=this.tblData.page;
          custlist.limit=this.tblData.limit;
          custlist.sortBy=this.tblData.sortBy;
          custlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.custlist=custlist;
          this.$store.commit("filter", filter);
      }
    },   
    rowEdit(record) {
      this.rowClicked(record);
      this.edit();
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },

    add: function() {
      this.saveFilter();
      if (this.namamenu=='sales.customer') {
          router.push({name :'sales.customerfrm'});
      } else if (this.namamenu=='koran.customer'){
          router.push({name :'koran.customerfrm'});
      } else if (this.namamenu=='iklankoran.customer'){
          router.push({name :'iklankoran.customerfrm'});
      } else {
          router.push({name :'receivable.customerfrm'});
      }
    },
    edit: function() {
      if (this.terpilih.customer_id) {
        this.saveFilter();
        if (this.namamenu=='sales.customer') {
            router.push({name :'sales.customerfrm', params: { customer_id: this.terpilih.customer_id}});
        } else if (this.namamenu=='koran.customer'){
            router.push({name :'koran.customerfrm', params: { customer_id: this.terpilih.customer_id}});
        } else if (this.namamenu=='iklankoran.customer'){
            router.push({name :'iklankoran.customerfrm', params: { customer_id: this.terpilih.customer_id}});
        } else {
            router.push({name :'receivable.customerfrm', params: { customer_id: this.terpilih.customer_id}});
        }
      } else {
            toastr.warn('Please select a row that want to be Edit!');
      }
    },
    deleteConfirm() {
      if (this.terpilih.customer_id) {
        this.showDelConfirm = true;
      } else {
            toastr.warn('Please select a row that want to be Deleted!');
      }
    },
    deleteData: async function() {
          try {
            await customer.remove(this.terpilih);
            this.refresh();
          } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
          }
    },
    rowClicked(record, index) {
      // if (this.terpilih.customer_id==record.customer_id) {
      //   this.edit();
      // } else {
        if ((this.terpilih) && (this.terpilih._rowVariant)) {
            delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },

    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await customer.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error), 'ERROR MESSAGE',10000);
            }
        }
    },
    close(){
      router.push({path:"home"});
    },    

  }
};
</script>
